import React, { useEffect, useRef, useState } from 'react';

export const LIVE_CALL_CYCLE_MS = 5000;
export const LIVE_CALL_FADE_MS = 2500;

const randomChannel = () => Math.floor(Math.random() * 256);

const randomRgba = () => {
  const alpha = 0.38 + Math.random() * 0.32;
  return `rgba(${randomChannel()}, ${randomChannel()}, ${randomChannel()}, ${alpha.toFixed(2)})`;
};

export const createRandomLiveCallGradient = () => {
  const angle = Math.floor(Math.random() * 360);
  const stopCount = 2 + Math.floor(Math.random() * 2);
  const stops = Array.from({ length: stopCount }, (_, index) => {
    const position = stopCount === 1
      ? 0
      : Math.round((index / (stopCount - 1)) * 100);
    return `${randomRgba()} ${position}%`;
  });
  return `linear-gradient(${angle}deg, ${stops.join(', ')})`;
};

export function LiveCallBubbleBackdrop({ active, messageId }) {
  const [gradients, setGradients] = useState(() => [
    createRandomLiveCallGradient(),
    createRandomLiveCallGradient(),
  ]);
  const [visibleIndex, setVisibleIndex] = useState(0);
  const visibleIndexRef = useRef(0);

  useEffect(() => {
    if (!active || !messageId) {
      return undefined;
    }

    const cycleGradient = () => {
      const nextVisibleIndex = 1 - visibleIndexRef.current;
      setGradients((current) => {
        const updated = [...current];
        updated[nextVisibleIndex] = createRandomLiveCallGradient();
        return updated;
      });
      visibleIndexRef.current = nextVisibleIndex;
      setVisibleIndex(nextVisibleIndex);
    };

    cycleGradient();
    const intervalId = window.setInterval(cycleGradient, LIVE_CALL_CYCLE_MS);
    return () => window.clearInterval(intervalId);
  }, [active, messageId]);

  if (!active) {
    return null;
  }

  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-none live-call-bubble-backdrop"
      aria-hidden="true"
    >
      {gradients.map((gradient, index) => (
        <div
          key={index}
          className="absolute inset-0"
          style={{
            backgroundImage: gradient,
            opacity: visibleIndex === index ? 1 : 0,
            transition: `opacity ${LIVE_CALL_FADE_MS}ms ease-in-out`,
          }}
        />
      ))}
    </div>
  );
}
